<template>
  <section
    class="component-ff839c09"
    resmed-component-name="all-online-retailers"
  >
    <div class="component">
      <nav class="py-4">
        <div class="container px-xs-sm-2">
          <div class="row">
            <div class="col-md-6 py-3 py-md-0 d-flex justify-content-center">
              <a
                v-on:click.capture="
                  $root.datalayer.push({
                    event: 'onlineStoreLocatorClick',
                    action: 'Go to Offline Dealer Locator',
                    location: undefined,
                  })
                "
                href="/sleep-apnea/find-cpap-supplies-near-me/"
                class="find-store-near-you"
                >Find CPAP <br class="d-none d-md-block d-lg-none" />store near
                you</a
              >
            </div>
            <div class="col-md-6 pt-2 pt-md-0 d-flex justify-content-center">
              <a
                href="#"
                class="filter-products-offered"
                v-bind:class="{ 'filters-is-active': filters.applied.length }"
                v-on:click.prevent="filters.active = true"
                >{{ $getTranslation("Filter by", $route.params.region) }} <br class="d-none d-md-block d-lg-none" />products
                offered</a
              >

              <div v-if="filters.active" class="filters">
                <header>
                  <h4>Filters</h4>
                  <a href="#" v-on:click.prevent="filters.active = false"></a>
                </header>
                <ul>
                  <li
                    v-for="filter in filters.values"
                    v-bind:class="{
                      'is-active': filters.applied.includes(filter),
                    }"
                  >
                    <a
                      v-on:click.prevent="
                        (!filters.applied.includes(filter) &&
                          $set(filters.applied, 0, filter)) ||
                          (filters.applied = [])
                      "
                      href="#"
                      >{{ filter }}</a
                    >
                  </li>
                </ul>
                <div class="apply" v-if="filters.applied.length">
                  <a
                    href="#"
                    v-on:click.prevent="filters.active = false"
                    class="btn cta-pill filled-red"
                    >Apply</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>
      <div class="container px-xs-sm-2 pt-5 pb-6">
        <header>
          <h3>All authorized online stores</h3>
          <!-- <p class="d-block d-md-none pt-2 pb-1 applied-filter" v-if="filters.applied.length"><strong>Applied filter: </strong><span v-on:click="filters.applied.pop()">{{ filters.applied[0] }}</span></p> -->
          <div
            class="sort"
            v-bind:class="{ 'is-active': sort.active }"
            v-on:mouseleave="sort.active = false"
          >
            <span v-on:click="sort.active = !sort.active"
              >{{ sort.label }}{{ sort.append }}</span
            >
            <ul v-if="sort.active">
              <li
                v-for="item in ['Default View', 'A-Z', 'Z-A']"
                v-bind:class="{ 'is-active': sort.applied === item }"
              >
                <a
                  v-on:click.prevent="
                    (sort.applied = item) && (sort.active = false)
                  "
                  href="#"
                  >{{ item }}</a
                >
              </li>
            </ul>
          </div>
        </header>
        <div class="items mb-4">
          <div class="item" v-for="item in paginated[pages.active - 1]">
            <div>
              <h3>{{ item.name }}</h3>
              <div class="filters">
                <ul>
                  <li
                    v-for="filter in filters.values"
                    v-if="item.filters.includes(filter)"
                    v-bind:class="{
                      'is-active': filters.applied.includes(filter),
                    }"
                  >
                    <span href="#">{{ filter }}</span>
                  </li>
                </ul>
              </div>
              <div class="cta">
                <a
                  target="_blank"
                  v-on:click="
                    $root.datalayer.push({
                      event: 'onlineStoreLocatorClick',
                      action: 'Full List - Visit Online Store',
                      location: item.name,
                    })
                  "
                  v-bind:href="item.website | protocol"
                  class="btn cta-plain text-red icon right-arrow"
                  >Buy online</a
                >
              </div>
            </div>
          </div>
        </div>
        <div class="pagination">
          <a
            href="#"
            v-on:click.prevent="pages.active > 1 && (pages.active -= 1)"
            class="prev"
          ></a>
          <ul>
            <li
              v-for="n in paginated.length"
              v-bind:class="{ 'is-active': pages.active === n }"
            >
              <a href="#" v-on:click.prevent="pages.active = n">{{ n }}</a>
            </li>
          </ul>
          <a
            href="#"
            class="next"
            v-on:click.prevent="
              pages.active < paginated.length && (pages.active += 1)
            "
          ></a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import scroll from "../../mixins/scroll";
import orderby from "lodash/orderBy";
import wpApi from "../../services/wpApi";

export default {
  name: "component-ff839c09", // all-online-retailers
  props: ["acf"],
  data() {
    return {
      filters: {
        active: false,
        values: [
          "CPAP machine",
          "CPAP mask",
          "AirMini travel CPAP",
          "AirTouch memory foam mask",
        ],
        applied: [],
        map: {
          "CPAP machine": "cpap-machine",
          "CPAP mask": "cpap-mask",
          "AirMini travel CPAP": "airmini",
          "AirTouch memory foam mask": "airtouch",
        },
      },
      pages: {
        active: 1,
        n: 0, // number of items per page
      },
      sort: {
        active: false,
        label: "Sort by",
        applied: "Default View",
        append: "",
      },
      sorted: [],
      response: [],
    };
  },
  mixins: [scroll],
  computed: {
    items() {
      let arr = this.sorted.filter((item) => {
        if (!this.filters.applied.length) {
          return true;
        }

        return item.filters.includes(this.filters.applied[0]);
      });

      return arr;
    },
    paginated() {
      let clone = this.items.slice(0);
      let arr = [];

      while (clone.length) {
        arr.push(clone.splice(0, this.pages.n));
      }
      return arr;
    },
  },
  watch: {
    "filters.active"(val) {
      val && (this.sort.active = false);

      if (!val) {
        this.$root.datalayer.push({
          event: "onlineStoreLocatorClick",
          action: "Filter Applied",
          filter: this.filters.applied[0],
        });
      }
    },
    "filters.applied"(val) {
      this.pages.active = 1; // reset pagination

      if (!val.length) {
        this.$root.datalayer.push({
          event: "onlineStoreLocatorClick",
          action: "Clear Filters",
          filter: "(not set)",
        });
      }
    },
    "sort.applied"(arg) {
      let arr = [],
        direction = arg === "A-Z" ? "asc" : "desc";

      this.$root.datalayer.push({
        event: "onlineStoreLocatorClick",
        action: "Sort",
        type: arg,
      });

      this.sorted =
        arg === "Default View"
          ? this.response
          : orderby(
              this.items,
              (a) => {
                return a.name.toLowerCase();
              },
              direction
            );
      this.sort.append =
        this.sort.applied === "Default View" ? "" : `: ${this.sort.applied}`; // append to label A-Z or Z-A
      this.pages.active = 1; // reset pagination
    },
    "pages.active"() {
      this.scroll({ to: "html" });
    },
  },
  filters: {
    protocol(value) {
      return value.indexOf("://") > -1 ? value : `http://${value}`;
    },
  },
  methods: {
    href(item) {
      if (!this.filters.applied.length) {
        return item.website;
      } else {
        return item.filters[this.filters.map[this.filters.applied[0]]];
      }
    },
  },
  created() {
    switch (this.$root.mode) {
      case "xl":
        this.pages.n = 16;
        break;
      case "lg":
      case "md":
        this.pages.n = 15;
        break;
      default:
        this.pages.n = 8;
    }

    wpApi.getOnlineDealerLocator()
      .then((response) => {
        let arr = [];

        // default sorting criteria
        // from resmed: the default view is sorted A-Z for those stores that sell all 4 products,
        // then A-Z for stores that sell 3 products, then A-Z for stores that sell 2 of the products
        for (let i of [4, 3, 2]) {
          for (let value of response.data) {
            if (value.filters.length === i) {
              arr.push(value);
            }
          }
        }

        this.response = arr;
        this.sorted = arr;
      });

    // pre-selected filter
    // example: #filter=cpap_machine
    let hash = window.location.hash.substring(1).replace("filter=", ""),
      arr = [
        "cpap_machine",
        "cpap_mask",
        "airmini_travel_cpap",
        "airtouch_mask",
      ]; // client request. do not change vals.

    let map = {
      cpap_machine: "CPAP machine",
      cpap_mask: "CPAP mask",
      airmini_travel_cpap: "AirMini travel CPAP",
      airtouch_mask: "AirTouch memory foam mask",
    };

    if (arr.includes(hash)) {
      this.filters.applied[0] = map[hash]; // apply filter
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-ff839c09 {
  // -->
}

.component {
  %close-x {
    display: block;
    width: 1.25rem;
    height: 1.25rem;
    background-repeat: no-repeat;
    background-size: 1rem 1rem;
    background-position: center center;
    background-image: url(#{$assets}/images/icon-close-white.svg);
    padding: 0;
  }

  %filters-list {
    li {
      padding: 0;

      background-repeat: no-repeat;
      background-position: 1rem center;
      opacity: 0.5;
      transition: opacity 1s;
      text-align: left;

      &:nth-child(1) {
        background-size: 25px 21px;
        background-image: url(#{$assets}/images/icon-filters-machine.png);
      }
      &:nth-child(2) {
        background-size: 21px 25px;
        background-position: 1.25rem center;
        background-image: url(#{$assets}/images/icon-filters-masks.png);
      }
      &:nth-child(3) {
        background-size: 30px 20px;
        background-position: 0.875rem center;
        background-image: url(#{$assets}/images/icon-filters-travel.png);
      }
      &:nth-child(4) {
        background-size: 27px 18px;
        background-image: url(#{$assets}/images/icon-filters-foam.png);
      }

      &:hover {
        background-color: rgba($cc-resmed-grey-15, 0.6);
      }

      &.is-active {
        background-color: rgba($cc-resmed-grey-15, 0.6);
        opacity: 1;

        a {
          color: $cc-resmed-black;

          background-repeat: no-repeat;
          background-size: 0.75rem 0.75rem;
          background-position: calc(100% - 1.625rem) center;
          background-image: url(#{$assets}/images/icon-active-blue.png);
        }
      }

      a,
      span {
        display: block;
        color: $cc-resmed-black;
        padding: 1.125rem 1rem 1.125rem 3.5rem;
      }
    }
  }

  nav {
    background-color: #f1f4f7;

    .container {
      max-width: 620px;
    }

    [class*="col-"] {
      text-align: center;

      @media (min-width: 768px) and (max-width: 991px) {
        text-align: left;
        padding-right: 2rem;
        padding-left: 2rem;
      }
    }

    a {
      color: $cc-resmed-black;
      display: inline-block;
      padding-left: 2rem;
      background-position: left center;
      background-repeat: no-repeat;
      transition: color 0.5s;

      @media (min-width: 768px) and (max-width: 991px) {
        padding-left: 2.5rem;
      }

      &:hover {
        color: $cc-resmed-pulse-blue;
      }

      &.filters-is-active {
        color: $cc-resmed-pulse-blue;
      }
    }

    .cpap-stores {
      background-image: url(#{$assets}/images/icon-shopping-cart-black.svg);
    }
    .find-store-near-you {
      background-image: url(#{$assets}/images/icon-compass-black.svg);
    }
    .filter-products-offered {
      background-image: url(#{$assets}/images/icon-filter-lines-black.svg);

      &.filters-is-active {
        position: relative;
        background-image: url(#{$assets}/images/icon-filter-lines-blue.svg);

        &:after {
          position: absolute;
          right: -1.5rem;
          content: "";
          width: 0.75rem;
          height: 1rem;
          background-repeat: no-repeat;
          background-size: 0.75rem 0.75rem;
          background-position: center center;
          background-image: url(#{$assets}/images/icon-active-blue.png);
        }
      }
    }

    .filters {
      width: 360px;
      position: absolute;
      z-index: 1;
      top: 3.375rem;
      background-color: $cc-resmed-white;
      box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.125);

      @media (min-width: 768px) {
        top: 4.5rem;
        transform: translateX(-3.8rem);
      }

      @media (min-width: 992px) {
        top: 3.375rem;
        transform: translateX(0);
      }

      @media (min-width: 1200px) {
        transform: translateX(4.2rem);
      }

      header {
        display: flex;
        justify-content: flex-end;
        padding: 1rem 1.5rem;
        background-color: $cc-resmed-action-red;
        text-align: left;

        h4 {
          flex-grow: 1;
          color: $cc-resmed-white;
          margin: 0;
        }

        a {
          @extend %close-x;
        }
      }

      ul {
        list-style: none;

        &.empty {
          border-bottom: 1px solid $cc-resmed-grey-15;
        }

        @extend %filters-list;
      }

      .apply {
        text-align: center;
        margin: 1.5rem auto 2.5rem auto;
      }
    }
  }

  .container > header {
    margin-bottom: 1rem;

    @media (min-width: 768px) {
      height: 44px;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
    }

    h3 {
      margin: 0;
    }

    // .applied-filter {
    //     span {
    //         cursor: pointer;
    //         display: inline-block;

    //         background-repeat: no-repeat;
    //         background-position: calc(100% - .5rem) center;
    //         background-size: .875rem .875rem;
    //         background-image: url(#{$assets}/images/icon-applied-filters-x.png);

    //         margin-left: .325rem;
    //         padding-right: 2rem;
    //     }
    // }

    .sort {
      position: relative;
      background-color: #eaeff6;
      background-position: calc(100% - 1.25rem) 1rem;
      background-repeat: no-repeat;
      background-image: url(#{$assets}/images/form-dropdown-caret.svg);
      background-size: 0.675rem 0.675rem;
      border-radius: 6px;
      @extend %body-small;
      color: rgba($cc-resmed-black, 0.75);

      @media (max-width: 767px) {
        margin: 1rem auto 0.625rem auto;
      }

      &.is-active {
        color: rgba($cc-resmed-black, 0.325);
        background-image: url(#{$assets}/images/form-dropdown-caret-up.svg);
      }

      span {
        @extend %body-small-bold;
        display: block;
        padding: 0.75rem 1.5rem;
        border-radius: 6px;
        cursor: pointer;
        height: auto;

        @media (min-width: 768px) {
          width: 170px;
        }
      }

      ul {
        display: absolute;
        list-style: none;

        padding: 0.25rem 1rem 0.75rem 1rem;

        li {
          margin-bottom: 0.5rem;

          &:last-child {
            margin-bottom: 0;
          }

          &.is-active {
            a {
              @extend %body-small-bold;
              cursor: default;
            }
          }

          a {
            color: rgba($cc-resmed-black, 0.75);
            display: block;

            // &:hover {
            //     color: $cc-resmed-white;
            // }
          }
        }
      }
    }
  }

  .items {
    display: flex;
    flex-grow: 1;
    flex-basis: 0;
    flex-wrap: wrap;
    margin: 0 -0.5rem;

    .item {
      padding: 0.5rem;
      width: 100%;
      min-height: 264px;
      background-color: $cc-resmed-white;

      @media (min-width: 768px) {
        width: 50%;
      }

      @media (min-width: 992px) {
        width: 33.33333%;
      }

      @media (min-width: 1200px) {
        width: 25%;
      }

      h3 {
        color: $cc-resmed-action-red;
        padding-bottom: 1rem;
        margin-bottom: 1rem;
        border-bottom: 1px solid $cc-resmed-grey-15;

        font-size: $font-size-lg;
      }

      .filters {
        flex-grow: 1;

        ul {
          list-style: none;
          margin-bottom: 1rem;

          @extend %filters-list;

          li {
            opacity: 1;
            cursor: default;
            background-color: inherit !important;

            &:hover {
              background-color: initial;
            }

            &:nth-child(1) {
              background-size: 21px 18px;
              background-position: 4px 12px;
            }
            &:nth-child(2) {
              background-size: 18px 21px;
              background-position: 6px 8px;
            }
            &:nth-child(3) {
              background-size: 27px 17px;
              background-position: 0 10px;
            }
            &:nth-child(4) {
              background-size: 25px 15px;
              background-position: 4px 12px;

              @media (min-width: 1200px) {
                padding-right: 1.5rem;
              }
            }

            &.is-active {
              span {
                color: $cc-resmed-pulse-blue;
                @extend %body-normal-bold;
              }

              &:nth-child(1) {
                background-image: url(#{$assets}/images/icon-filters-machine-blue.png);
              }
              &:nth-child(2) {
                background-image: url(#{$assets}/images/icon-filters-masks-blue.png);
              }
              &:nth-child(3) {
                background-image: url(#{$assets}/images/icon-filters-travel-blue.png);
              }
              &:nth-child(4) {
                background-image: url(#{$assets}/images/icon-filters-foam-blue.png);
              }
            }

            span {
              padding: 0.5rem 1rem 0.5rem 2.5rem;

              &:hover {
                background-color: inherit !important;
              }
            }
          }
        }
      }

      > div {
        display: flex;
        flex-direction: column;
        height: 100%;
        box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.125);
        border-radius: 6px;
        transition: all 0.5s;
        padding: 1.5rem;

        .cta {
          a {
            transition: all 0.5s;
          }
        }
      }
    }
  }

  .pagination {
    display: flex;
    align-items: center;

    > a {
      display: inline-block;
      width: 2rem;
      height: 2rem;
      background-repeat: no-repeat;
      background-size: contain;

      &.prev {
        margin-right: 1rem;
        background-image: url(#{$assets}/images/pagination-left-arrow.png);
      }
      &.next {
        margin-left: 1rem;
        background-image: url(#{$assets}/images/pagination-right-arrow.png);
      }
    }

    ul {
      list-style: none;
      display: flex;

      li {
        @extend %body-normal-bold;
        margin: 0 0.5rem;

        &.is-active {
          a {
            color: $cc-resmed-grey-30;
            cursor: default;
          }
        }

        a {
          color: $cc-resmed-black;
        }
      }
    }
  }
}
</style>